// extracted by mini-css-extract-plugin
export var container = "_e5-0";
export var infoIcon = "_e5-2";
export var internalLabel = "_e5-3";
export var titleRowCol = "_e5-1";